import { GRATA_DEV_PROJECT_ID, GRATA_PROD_PROJECT_ID } from "../../helper/constants";
import { STATUS_MAP } from "../../utils/mappings";
const PinRelatedCategoryId = 35;
const RequestCategoryAddGuestPIN    = "Add Guest PIN"
const RequestCategoryRemoveGuestPIN = "Remove Guest PIN"
const RequestCategoryChangePIN = "Change PIN Code"
const AssignOperatorProcess = {
  Pending: 'Pending'
}

const RequestStatus = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
  ARCHIVED: 'Archived',
  CALL: 'Call',
  SCHEDULED: 'Scheduled',
  ON_HOLD: 'On Hold',
  REASSIGNMENT: 'Reassignment',
  WEB: 'Web',
}

const convertServiceStatusToId = (status) => {
  return STATUS_MAP.filter((statusObj) => statusObj.value === status)[0]?.id;
}

const convertServiceIdToStatus = (id) => {
  return STATUS_MAP.filter((statusObj) => statusObj.id === id)[0]?.value;
}

const StatusBGVariants = {
  [RequestStatus.OPEN]: 'primary',
  [RequestStatus.IN_PROGRESS]: 'warning',
  [RequestStatus.COMPLETE]: 'success',
}

const YARDI_MAX_CHARACTERS = 45;
const NON_YARDI_MAX_CHARACTERS = 64;

// Display label for status "In Progress" (status ID 13)
export const STATUS_LABEL_ASSIGNED = 'Assigned';

const YARDI_DEV_ORG_ID = 246;
const WESTERN_SECURITIES_4SL_ORG_PROD_ID = 121;

const orgsWithOrgWideYardiLookup = {
  [GRATA_DEV_PROJECT_ID]: [YARDI_DEV_ORG_ID],
  [GRATA_PROD_PROJECT_ID]: [WESTERN_SECURITIES_4SL_ORG_PROD_ID],
};

const isOrgWithOrgWideYardiLookup = (orgId) => {
  return orgsWithOrgWideYardiLookup[process.env.REACT_APP_PROJECT_ID]?.includes(orgId);
};

export {
  PinRelatedCategoryId,
  RequestCategoryAddGuestPIN,
  RequestCategoryRemoveGuestPIN,
  RequestCategoryChangePIN,
  AssignOperatorProcess,
  RequestStatus,
  StatusBGVariants,
  convertServiceStatusToId,
  convertServiceIdToStatus,
  YARDI_MAX_CHARACTERS,
  NON_YARDI_MAX_CHARACTERS,
  YARDI_DEV_ORG_ID,
  WESTERN_SECURITIES_4SL_ORG_PROD_ID,
  orgsWithOrgWideYardiLookup,
  isOrgWithOrgWideYardiLookup,
}
